// @ts-ignore
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../../imageLarge.fragment.generated';
export const QuestionnaireSignUpStepFragmentDoc = gql`
    fragment questionnaireSignUpStep on QuestionnaireSignUpStep {
  title
  description
  backgroundColor
  image {
    ...imageLarge
  }
}
    ${ImageLargeFragmentDoc}`;